import { FMCardProps } from '@own/fds-react/dist/types/fm-card.types';
import { DyfFdsButtonProps } from '../../../../../views/dyf-landing-view/hooks/use-dyf-fds-buttons';
import { DyfFdsCardProps } from '../../../../../views/dyf-landing-view/hooks/use-dyf-fds-cards';

export { useGVTCard } from './gvt-card';
export { useHTVCard } from './htv-card';
export { useLivestreamCard } from './livestream-card';

export const generateFMCardProps = (
    cardAemContent: DyfFdsCardProps,
    cardButtonAemContent: DyfFdsButtonProps,
    href: string,
    mediaSrc: string,
    onClick: (x: string, y: string) => void,
    modelName?: string
): FMCardProps => {
    return {
        borderless: true,
        ctaAriaLabel: cardAemContent?.title,
        ctaChevron: 'right',
        ctaHref: href,
        ctaLabel: cardButtonAemContent?.buttonLabel,
        ctaTarget: '_self',
        ctaTheme: 'light',
        ctaType: 'primary',
        description: addModelToCard(
            cardAemContent?.body || '',
            modelName ?? ''
        ),
        imageAlt: cardAemContent?.mediaAltText || '',
        imageSrc: mediaSrc,
        title: cardAemContent?.title,
        ctaOnClick: () =>
            onClick(
                cardAemContent.title.toLowerCase(),
                cardButtonAemContent.buttonLabel.toLowerCase()
            ),
    };
};

export function addModelToCard(str: string, modelDisplayName: string): string {
    return str.replace('[model]', modelDisplayName);
}
